define('SageDotCom/Components/ProductCardFeatureList',["jquery", "eventManager"],
    function ($, eventManager) {
        function ProductCardFeatureList(scope, itemContext, itemLang) {
            //Create global params
            let $modal = $(scope).find(".product-feature-alert");
            let $featureList = $(scope).find("[id*='feature-list']");
            let featureListId = $featureList.attr("id");
            let $modalId = featureListId + "-modal";

            var focusableElements;
            var firstElement;
            var lastElement;
            var prevFocusableElement;

            //Remove the specific modal under the feature list & append to body for styling 
            $modal.detach();
            $('body').append($modal);

            attachFeatureCTAClick();

            $(window).resize(function () {
                attachFeatureCTAClick();
            });

            var attachTimeout = undefined;
            function attachFeatureCTAClick() {
                clearTimeout(attachTimeout);
                attachTimeout = setTimeout(function () {
                    // remove old event listeners and reattach so that the events still fire when in slick slider
                    $(scope).off('click').on('click', '.feature-cta', function () {
                        let featureItemId = $(this).attr('id');
                        getFeatureInfo(featureItemId, itemContext, itemLang);
                    });
                }, 1000);
            }

            $modal.on("shown.bs.modal", function (e) {
                // needs to run on shown so that scope of focusable buttons does not change
                focusableElements = Array.from(e.target.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar)'));
                prevFocusableElement = document.activeElement;

                if (focusableElements != null && focusableElements.length > 0) {
                    firstElement = focusableElements[0];
                    lastElement = focusableElements[focusableElements.length - 1];
                }
                trapFocus(true, firstElement, lastElement, prevFocusableElement);
            });

            $modal.on("hidden.bs.modal", function (e) {
                trapFocus(false, firstElement, lastElement, prevFocusableElement);
            });

            function updateCurrModal(result) {
                let modal = document.getElementById($modalId);
                let modalBody = modal.querySelector(".modal-body");

                modalBody.innerHTML = result;
                $modal.modal("show");
                $($modal).find(".modal-body").animate({
                    scrollTop: 0
                }, 500);

                eventManager.trigger("invoke-lazy-load");
                $(".sage-loader").removeClass("show");
            }

            function getFeatureInfo(featureId, context, lang) {
                $.ajax({
                    type: "GET",
                    url: '/api/sagedotcom/externalproductapi/getfeaturedataasync',
                    data: {
                        featureId: featureId,
                        context: context,
                        lang: lang
                    },
                    success: function(response) {
                        if (response !== "") {
                            updateCurrModal(response);
                        } else {
                            //Still remove loader if data is empty, should never be empty (content issue)
                            $(".sage-loader").removeClass("show");
                        }
                    }
                }).fail(function () {
                    //Don't block the page
                    $(".sage-loader").removeClass("show");
                });
            }

            function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
                const handleFocus = e => {

                    if (e.keyCode == 9) {
                        if (!e.shiftKey && $(e.target).is(lastElement)) {
                            e.preventDefault();
                            firstElement.focus();
                        } else if (e.shiftKey && $(e.target).is(firstElement)) {
                            e.preventDefault();
                            lastElement.focus();
                        }
                    }
                };

                if (isModalOpen) {
                    firstElement.focus();
                    document.addEventListener("keydown", handleFocus, true);
                }
                else {
                    document.removeEventListener("keydown", handleFocus, true);
                    prevFocusableElement.focus();
                }
            }
        }

        ProductCardFeatureList.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ProductCardFeatureList(args.scope, args.itemContext, args.itemLang);
        };

        return ProductCardFeatureList;
    });
